import { SiteMasterListItemModel } from '@customer-portal/data-access/global';
import { EventAction } from '@customer-portal/shared';

export interface SettingsSitesItemModel extends SiteMasterListItemModel {
  eventActions?: EventAction;
}

export interface SaveSiteNicknamePayload {
  siteId: number;
  siteNickname: string;
}
